module.exports = __webpack_public_path__ + "c0b35e6e765d72cf149e3ba279f4f59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/dairyserve.png
// module id = 1363
// module chunks = 0